document.addEventListener("DOMContentLoaded", () => {
  const addToCartForms = document.querySelectorAll("form[action='/cart/add']");

  addToCartForms?.forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      console.log(e);

      const formData = new FormData(form);

      console.log(formData);

      // await fetch("/cart/add", {
      //   method: "post",
      //   body: formData
      // });
    });
  });
});

// window.onpageshow = function (event) {
//   console.log("Hello", event);

//   // Reset all file inputs so they can trigger 'change' event when the same file is selected
//   document.querySelectorAll(".kps_hide_my_uploader").forEach((input) => {
//     input.value = ""; // Clear the file input
//   });
// };

// Add event listener for the file input
document.querySelectorAll(".kps_hide_my_uploader").forEach((input) => {
  input.addEventListener("change", function (e) {
    console.log(e);

    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const elm = e.target;
      const fileNumber = elm.getAttribute("data-filenumber");
      const imagePreview = document.getElementById(
        `kps_imagePreview_${fileNumber}`
      );

      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = function (e) {
          imagePreview.src = e.target.result;

          e.target.value = e.target.result;

          imagePreview.style.display = "block";
        };
        reader.readAsDataURL(file);
      } else {
        imagePreview.style.display = "none";
      }
    }
  });
});
